import { useEffect, useState } from 'react';

import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import { Button, color, type ColorType, Icon, Tag } from '@wf/components';
import { Tooltip } from '@wf/sw-ui-kit';

import RiskTooltipContent, { colorNameByRiskColor } from './RiskTooltipContent';

import { RiskColor } from '../../types/enums';

import { getLpcoRisks } from '../../services/risk';

import styles from './RiskStatus.module.scss';

const riskIconNamesByColor: Record<RiskColor, string> = {
  [RiskColor.GREEN]: 'ic_clean',
  [RiskColor.BLUE]: 'ic_post_clearance',
  [RiskColor.YELLOW]: 'ic_documentarycheck',
  [RiskColor.ORANGE]: 'ic_X_rey',
  [RiskColor.RED]: 'ic_physical_examination',
  [RiskColor.PURPLE]: 'ic_OGA_inspection',
  [RiskColor.NONE]: '',
};

interface IRiskItem {
  color: RiskColor;
}

function RiskStatus() {
  const { t } = useTranslation();
  const { id = '' } = useParams();
  const [riskData, setRiskData] = useState<IRiskItem | null>(null);

  useEffect(() => {
    async function getRisk() {
      try {
        const { data } = await getLpcoRisks(id);
        const currentItem = data.at(-1);

        if (currentItem) {
          const { finalColor } = currentItem;

          setRiskData({
            color: finalColor,
          });
        }
      } catch (e) {
        console.error(e);
      }
    }

    void getRisk();
  }, [id]);

  return (
    <>
      {riskData ? (
        <div className={styles.wrapper}>
          <div className={styles.line} />
          <Tooltip
            tooltipContent={<RiskTooltipContent colorName={riskData.color} />}
            contentClassName={styles.tooltipContent}
            triggers={['click']}
            placement="bottom"
            offset={-4}
          >
            <Button ghost>
              <Tag
                style={{ background: color(colorNameByRiskColor[riskData.color] as ColorType, 90) }}
                icon={<Icon name={riskIconNamesByColor[riskData.color]} />}
                color="typography"
              >
                {t(riskIconNamesByColor[riskData.color])}
              </Tag>
            </Button>
          </Tooltip>
        </div>
      ) : null}
    </>
  );
}

export default RiskStatus;
